import React from "react";
import Hero from "../landing_new/Hero";
import NavBar from "../landing_new/Navbar/NavBar";

const Home = () => {
  return (
    <>
      <NavBar />
      <Hero />
    </>
  );
};

export default Home;
